module.exports = __webpack_public_path__ + "img/TimeClockHourglass.30c486cb.png";